import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Elite Mind: the squad dashboard and the athlete list.
 *
 * Reports are counted only where the athlete switched on "share with team".
 * The daily journal has no such switch, so its contents — symptoms, sleep,
 * training compliance, notes — are never surfaced anywhere in this section, at
 * squad level or per athlete. Only that a journal is being kept, and how
 * regularly.
 */
const CompanyEliteMindLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  // "Athletes" reads right for a club in either mode, so it stays constant;
  // only the list tab follows the B2B/Members toggle.
  const pages = [
    {
      label: 'Squad Dashboard',
      path: `/${slug}/elite-mind`,
      description:
        'Who is registered, how well the journal habit is holding, and what athletes have shared'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Athletes',
      path: `/${slug}/elite-mind/users`,
      description: 'Per-athlete journal activity and shared reports'
    }
  ];

  return (
    <CompanySectionLayout
      title="Elite Mind"
      subtitle="Your athletes' journal habit, and the injury, symptom and concussion reports they have chosen to share with you."
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyEliteMindLayout;
